import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import ReactPlayer from "react-player";

// Embedded clip player with imperative seek. Supports YouTube, Twitch, Streamable,
// direct video files, and more (via react-player). Parent calls ref.seekTo(seconds).
export const ClipPlayer = forwardRef(({ url, testid = "clip-player", muted = false }, ref) => {
  const playerRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useImperativeHandle(ref, () => ({
    seekTo(seconds) {
      if (playerRef.current) {
        playerRef.current.seekTo(Math.max(0, seconds), "seconds");
        setPlaying(true);
      }
    },
  }));

  if (!url || !ReactPlayer.canPlay(url)) return null;

  return (
    <div data-testid={testid} className="relative w-full overflow-hidden rounded-lg border border-[#1E293F] bg-black" style={{ aspectRatio: "16 / 9" }}>
      <ReactPlayer
        ref={playerRef}
        url={url}
        controls
        playing={playing}
        muted={muted}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        width="100%"
        height="100%"
        style={{ position: "absolute", inset: 0 }}
        config={{ youtube: { playerVars: { modestbranding: 1, rel: 0 } } }}
      />
    </div>
  );
});
